import React from 'react';
import styles from './marketing.module.css';
import { SEO, organizationJsonLd } from '../components/SEO.jsx';
import birdImage from '../pictures/Letterbird.png';
import cityImage from '../pictures/Singapore Business District.png';

function ContactForm() {
  return (
    <main className={styles.page}>
      <SEO
        title="Contact Blockchain Systems"
        description="Contact Blockchain Systems about Back-Step Blockchain products, Trust.it, pilot projects, licensing, partnerships, and investor discussions."
        path="/contact"
        jsonLd={organizationJsonLd}
      />

      <section className={styles.hero}>
        <img className={styles.heroImage} src={cityImage} alt="Singapore skyline" />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <p className={styles.kicker}>Contact</p>
          <h1 className={styles.heroTitle}>Let us talk about the trust problem you want to solve.</h1>
          <p className={styles.heroText}>
            Reach us for product discussions, pilot projects, licensing, or investor conversations. We will route your message to the right person.
          </p>
          <div className={styles.actions}>
            <a className={styles.primaryAction} href="mailto:feedback@backstepchain.com">Email us</a>
            <a className={styles.secondaryAction} href="https://trust-it.app" target="_blank" rel="noreferrer">Visit Trust.it</a>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.split}>
          <div className={styles.splitCopy}>
            <span className={styles.tag}>How to reach us</span>
            <h2>Start with the business outcome.</h2>
            <p>
              Tell us what you need to prove, protect, certify, or store. A short description of the use case is enough for a first discussion.
            </p>
            <ul className={styles.list}>
              <li>Product or pilot enquiries: feedback@backstepchain.com</li>
              <li>Company contact: info@blockchainsystems.vip</li>
              <li>Priority access: registered Trust.it users can contact us through the app.</li>
            </ul>
          </div>
          <div className={styles.photoPanel}>
            <img src={birdImage} alt="Letter bird illustration" />
          </div>
        </div>
      </section>
    </main>
  );
}

export default ContactForm;
